import {
  sqConditionRuntimeStore,
  sqItemRuntimeStore,
  sqScalarRuntimeStore,
  sqSummaryReportStore,
  sqTableRuntimeStore,
  sqTrendScalingColumnStore,
} from '@/core/core.stores';
import { SummaryReportStoreProvider } from '@/summaryReport/summaryReport.store';
import { ConditionRuntimeStoreProvider } from '@/trendData/conditionRuntime.store';
import { ItemRuntimeStoreProvider } from '@/trendData/itemRuntime.store';
import { ScalarRuntimeStoreProvider } from '@/trendData/scalarRuntime.store';
import { TableRuntimeStoreProvider } from '@/trendData/tableRuntime.store';
import { TrendScalingColumnStoreProvider } from '@/trendData/trendScalingColumn.store';
import type { ReactNode } from 'react';

/**
 * Providers for the trend stores that have been converted from Flux to Zustand, wired to their
 * legacy singletons so hook readers and imperative writers share one instance.
 */
export const TrendStoreProviders = ({ children }: { children?: ReactNode }) => {
  return (
    <TrendScalingColumnStoreProvider store={sqTrendScalingColumnStore}>
      <ItemRuntimeStoreProvider store={sqItemRuntimeStore}>
        <ScalarRuntimeStoreProvider store={sqScalarRuntimeStore}>
          <SummaryReportStoreProvider store={sqSummaryReportStore}>
            <TableRuntimeStoreProvider store={sqTableRuntimeStore}>
              <ConditionRuntimeStoreProvider store={sqConditionRuntimeStore}>{children}</ConditionRuntimeStoreProvider>
            </TableRuntimeStoreProvider>
          </SummaryReportStoreProvider>
        </ScalarRuntimeStoreProvider>
      </ItemRuntimeStoreProvider>
    </TrendScalingColumnStoreProvider>
  );
};
